import { BREAKPOINTS, COLORS, ComponentL } from "@laerdal/life-react-components";
import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 32px 0 56px;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export { CaseTitle as Title, CaseSubTitle as Subtitle } from "./CommonCaseComponents";

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 6px 16px;
  border-radius: 4px;
  background: #d7edf6;
  margin: 70px 10px 0;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const BannerText = styled.div`
  color: ${COLORS.neutral_800};
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
`;

export const BannerSignInButton = styled.button`
  background: ${COLORS.white};
  color: ${COLORS.primary_700};
  border: none;
  box-shadow: none;
  height: 32px;
  min-width: 73px;
  width: 100%;
  padding: 0 14px;
  border-radius: 6px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  outline: none;

  ${BREAKPOINTS.MEDIUM} {
    width: auto;
  }

  &:hover {
    background: ${COLORS.neutral_20};
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.primary_200};
    outline-offset: 2px;
  }
`;

export const SearchSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const SectionTitle = styled.div`
  color: ${COLORS.neutral_800};
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
`;

export const ResultsBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ProductsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  width: 100%;

  ${BREAKPOINTS.MEDIUM} {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
    row-gap: 16px;
  }

  ${BREAKPOINTS.LARGE} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const PaginatorContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 12px;
  margin: 0;
  background: ${COLORS.neutral_20};
  border-radius: 8px;

  & > * {
    margin: 0;
  }
`;

export const CategoriesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
`;

export const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;

  ${BREAKPOINTS.MEDIUM} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${BREAKPOINTS.LARGE} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const CategoryCard = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 90px;
  width: 100%;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
  background: ${props => props.$active ? "#D4E9F2" : COLORS.white};
  padding: 0;
  cursor: pointer;
  text-align: left;
  overflow: hidden;

  &:hover {
    border-color: ${COLORS.neutral_400};
  }
`;

export const CategoryImage = styled.div`
  width: 70px;
  height: 100%;
  background: ${COLORS.neutral_20};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${BREAKPOINTS.MEDIUM} {
    width: 110px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CategoryLabel = styled.div`
  flex: 1;
  padding: 0 16px;
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  color: ${COLORS.neutral_800};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const CategoryProducts = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #F1FBFE;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
  padding: 16px;
  overflow: hidden;
  max-width: 100%;
  box-sizing: border-box;
`;

export const CategoryProductsTitle = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.neutral_800};
`;

export const LinkRow = styled.div`
  padding-top: 24px;
`;

export const LinkButton = styled.button`
  border: none;
  background: none;
  color: ${COLORS.primary};
  font-family: Lato;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;
